module.exports = __webpack_public_path__ + "img/don'tmissyourflight.0efa1619.svg";